import React from 'react'
import MaterialSymbol from '../material-symbol'

const Computer = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="computer" {...props} />
))

Computer.displayName = 'Computer'

export default Computer
